import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ApiStatsTab = ({ token }) => {
  const [overview, setOverview] = useState(null);
  const [topEndpoints, setTopEndpoints] = useState([]);
  const [daily, setDaily] = useState([]);
  const [errors, setErrors] = useState(null);
  const [responseTimes, setResponseTimes] = useState(null);
  const [loading, setLoading] = useState(true);

  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => {
    const fetch = async () => {
      try {
        const [ov, te, dl, er, rt] = await Promise.all([
          axios.get('/api/admin/api-stats/overview', { headers }),
          axios.get('/api/admin/api-stats/top-endpoints?limit=8', { headers }),
          axios.get('/api/admin/api-stats/daily?days=14', { headers }),
          axios.get('/api/admin/api-stats/errors', { headers }),
          axios.get('/api/admin/api-stats/response-times', { headers })
        ]);
        setOverview(ov.data.data);
        setTopEndpoints(te.data.data || []);
        setDaily(dl.data.data || []);
        setErrors(er.data.data);
        setResponseTimes(rt.data.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetch();
  }, [token]);

  if (loading) return <div className="empty">Yükleniyor...</div>;

  return (
    <div>
      {overview && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '12px', marginBottom: '20px' }}>
          <div className="item-card" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
            <div style={{ fontSize: '12px', color: '#6B7280' }}>Son 24s İstek</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#60A5FA' }}>{overview.last_24h.total_requests.toLocaleString()}</div>
          </div>
          <div className="item-card" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
            <div style={{ fontSize: '12px', color: '#6B7280' }}>Hata Oranı</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: overview.last_24h.error_rate > 5 ? '#FCA5A5' : '#34D399' }}>%{overview.last_24h.error_rate}</div>
          </div>
          <div className="item-card" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
            <div style={{ fontSize: '12px', color: '#6B7280' }}>Ort. Yanıt Süresi</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#E5E7EB' }}>{overview.last_24h.avg_response_time_ms}ms</div>
          </div>
          <div className="item-card" style={{ flexDirection: 'column', alignItems: 'flex-start', gap: '8px' }}>
            <div style={{ fontSize: '12px', color: '#6B7280' }}>Tüm Zamanlar</div>
            <div style={{ fontSize: '28px', fontWeight: '700', color: '#E5E7EB' }}>{overview.all_time.total_requests.toLocaleString()}</div>
          </div>
        </div>
      )}

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
        <div className="card">
          <h4 style={{ margin: '0 0 12px', color: '#E5E7EB', fontSize: '14px' }}>En Çok Kullanılan Endpoint'ler</h4>
          {topEndpoints.length === 0 ? <div className="empty" style={{ padding: '20px' }}>Veri yok</div> : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ color: '#6B7280', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                  <th style={{ padding: '6px 8px', textAlign: 'left' }}>Endpoint</th>
                  <th style={{ padding: '6px 8px', textAlign: 'right' }}>İstek</th>
                  <th style={{ padding: '6px 8px', textAlign: 'right' }}>Hata</th>
                </tr>
              </thead>
              <tbody>
                {topEndpoints.map((ep, i) => (
                  <tr key={i} style={{ borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                    <td style={{ padding: '8px', color: '#E5E7EB' }}><code style={{ fontSize: '12px' }}>{ep.method} {ep.endpoint}</code></td>
                    <td style={{ padding: '8px', textAlign: 'right', color: '#60A5FA' }}>{ep.request_count}</td>
                    <td style={{ padding: '8px', textAlign: 'right', color: ep.error_rate > 5 ? '#FCA5A5' : '#6B7280' }}>%{ep.error_rate}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="card">
          <h4 style={{ margin: '0 0 12px', color: '#E5E7EB', fontSize: '14px' }}>Yanıt Süre Dağılımı (7 gün)</h4>
          {responseTimes && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {[
                { label: '< 100ms', key: 'under_100ms', color: '#34D399' },
                { label: '100-300ms', key: 'between_100_300ms', color: '#60A5FA' },
                { label: '300-500ms', key: 'between_300_500ms', color: '#FCD34D' },
                { label: '500-1000ms', key: 'between_500_1000ms', color: '#FCA5A5' },
                { label: '> 1000ms', key: 'over_1000ms', color: '#EF4444' },
              ].map(item => {
                const total = Object.values(responseTimes).reduce((a, b) => a + (parseInt(b) || 0), 0);
                const val = parseInt(responseTimes[item.key]) || 0;
                const pct = total > 0 ? (val / total) * 100 : 0;
                return (
                  <div key={item.key}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '4px' }}>
                      <span style={{ color: '#9CA3AF' }}>{item.label}</span>
                      <span style={{ color: item.color }}>{val}</span>
                    </div>
                    <div style={{ height: '6px', background: 'rgba(255,255,255,0.06)', borderRadius: '3px', overflow: 'hidden' }}>
                      <div style={{ height: '100%', width: `${pct}%`, background: item.color, borderRadius: '3px', transition: 'width 0.5s' }} />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      <div className="card" style={{ marginBottom: '16px' }}>
        <h4 style={{ margin: '0 0 12px', color: '#E5E7EB', fontSize: '14px' }}>Günlük İstek Sayısı (14 gün)</h4>
        {daily.length === 0 ? <div className="empty" style={{ padding: '20px' }}>Veri yok</div> : (
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '4px', height: '120px' }}>
            {daily.map((d, i) => {
              const max = Math.max(...daily.map(x => x.request_count), 1);
              const h = (d.request_count / max) * 100;
              return (
                <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                  <div style={{ width: '100%', height: `${h}%`, background: 'linear-gradient(180deg, #3B82F6, #1D4ED8)', borderRadius: '4px 4px 0 0', minHeight: '4px', transition: 'height 0.3s' }} title={`${d.date}: ${d.request_count} istek`} />
                  <span style={{ fontSize: '9px', color: '#6B7280', transform: 'rotate(-45deg)', whiteSpace: 'nowrap' }}>{d.date?.slice(5)}</span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {errors && errors.errors?.length > 0 && (
        <div className="card">
          <h4 style={{ margin: '0 0 12px', color: '#E5E7EB', fontSize: '14px' }}>⚠️ En Sık Hata Alan Endpoint'ler</h4>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
            <thead>
              <tr style={{ color: '#6B7280', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
                <th style={{ padding: '6px 8px', textAlign: 'left' }}>Endpoint</th>
                <th style={{ padding: '6px 8px', textAlign: 'right' }}>Kod</th>
                <th style={{ padding: '6px 8px', textAlign: 'right' }}>Sayı</th>
              </tr>
            </thead>
            <tbody>
              {errors.errors.slice(0, 10).map((e, i) => (
                <tr key={i} style={{ borderBottom: '1px solid rgba(255,255,255,0.03)' }}>
                  <td style={{ padding: '8px', color: '#E5E7EB' }}><code style={{ fontSize: '12px' }}>{e.method} {e.endpoint}</code></td>
                  <td style={{ padding: '8px', textAlign: 'right', color: '#FCA5A5' }}>{e.status_code}</td>
                  <td style={{ padding: '8px', textAlign: 'right', color: '#E5E7EB' }}>{e.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ApiStatsTab;
